<app-simple-modal [title]="'Errores en archivo de entrada'" [requiredFields]="false" [max]="75" (close)="close.emit($event)">
	<div fields>
		<p>Hemos encontrado algunos errores en el archivo de entrada que debe corregir antes de subirlo: </p>
		<div class="table-responsive">
			<table class="table">
				<thead>
					<tr class="tr-middle">
						<th></th>
						<th>#</th>
						<th>Error</th>
						<th>Fila</th>
						<th>Columna</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let error of errors; let i = index" class="tr-middle">
						<td><i class="fa fa-times text-danger" aria-hidden="true"></i></td>
						<td>{{i + 1}}</td>
						<td>{{error.message}}</td>
						<td>{{error.line}}</td>
						<td>{{error.column}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</app-simple-modal>